// src/pages/Appli/AppliAdmin/VisitorCenter/components/VisitorTrafficChart.jsx

import React from "react";

import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import {
  EmptyState,
  SectionCard,
} from "../ui/VisitorCenterUi";

import {
  formatChartDate,
} from "../utils/visitorFormatters";

function CustomTooltip({
  active,
  payload,
  label,
}) {
  if (
    !active ||
    !payload?.length
  ) {
    return null;
  }

  return (
    <div className="min-w-[190px] rounded-2xl border border-slate-200 bg-white p-4 shadow-xl">
      <p className="font-extrabold text-[#123B57]">
        {formatChartDate(label)}
      </p>

      <div className="mt-3 space-y-2">
        {payload.map((item) => (
          <div
            key={item.dataKey}
            className="flex items-center justify-between gap-4 text-sm"
          >
            <span className="text-slate-500">
              {item.name}
            </span>

            <span className="font-extrabold text-slate-700">
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function VisitorTrafficChart({
  rows = [],
}) {
  return (
    <SectionCard
      title="Évolution du trafic"
      subtitle="Sessions, visiteurs et pages vues enregistrés chaque jour."
    >
      {rows.length ? (
        <div className="h-[390px] p-4 lg:p-6">
          <ResponsiveContainer
            width="100%"
            height="100%"
          >
            <ComposedChart
              data={rows}
              margin={{
                top: 12,
                right: 12,
                left: -18,
                bottom: 0,
              }}
            >
              <CartesianGrid
                strokeDasharray="4 4"
                vertical={false}
                stroke="#E2E8F0"
              />

              <XAxis
                dataKey="date"
                tickFormatter={
                  formatChartDate
                }
                tick={{
                  fill: "#64748B",
                  fontSize: 12,
                }}
                axisLine={false}
                tickLine={false}
                minTickGap={22}
              />

              <YAxis
                allowDecimals={false}
                tick={{
                  fill: "#64748B",
                  fontSize: 12,
                }}
                axisLine={false}
                tickLine={false}
              />

              <Tooltip
                content={
                  <CustomTooltip />
                }
              />

              <Legend
                wrapperStyle={{
                  paddingTop: 18,
                }}
              />

              <Bar
                dataKey="page_views"
                name="Pages vues"
                fill="#BAE6FD"
                radius={[
                  6,
                  6,
                  0,
                  0,
                ]}
                maxBarSize={36}
              />

              <Line
                type="monotone"
                dataKey="sessions"
                name="Sessions"
                stroke="#123B57"
                strokeWidth={3}
                dot={false}
                activeDot={{
                  r: 5,
                }}
              />

              <Line
                type="monotone"
                dataKey="visitors"
                name="Visiteurs"
                stroke="#2EA7E0"
                strokeWidth={3}
                dot={false}
                activeDot={{
                  r: 5,
                }}
              />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <EmptyState
          title="Aucune activité"
          description="Aucune visite n’a été enregistrée sur cette période."
        />
      )}
    </SectionCard>
  );
}